import { render, staticRenderFns } from "./ComingLottery.vue?vue&type=template&id=a136f68c&scoped=true"
import script from "./ComingLottery.vue?vue&type=script&lang=js"
export * from "./ComingLottery.vue?vue&type=script&lang=js"
import style0 from "./ComingLottery.vue?vue&type=style&index=0&id=a136f68c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a136f68c",
  null
  
)

export default component.exports